var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('router-link',{attrs:{"to":"/signin"}},[_c('div',{staticClass:"img_box"},[_c('img',{staticClass:"home_logo",attrs:{"src":_vm.homeLogo,"alt":""}}),_c('el-button',{staticClass:"home_btn",attrs:{"type":"primary"}},[_vm._v(" 手机号登录/注册 ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }